import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "arv-reactcomponents";

import ExchangeInitiate from "./ExchangeInitiate";
import ExchangeComplete from "./ExchangeComplete";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

class Exchange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      currentView: "exchangeInitiate",
    };

    this.closeModal = this.closeModal.bind(this);
    this.handleCurrentView = this.handleCurrentView.bind(this);
    this.handleExchange = this.handleExchange.bind(this);
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
      currentView: "exchangeInitiate",
    });
  }

  handleExchange(event) {
    event.preventDefault();
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
    Analytics.trackEvent({
      category: Event.category.ORDER_DETAIL,
      action: Event.action.EXCHANGE_CLICK,
    });
  }

  handleCurrentView(data) {
    this.setState({
      currentView: data ? "exchangeComplete" : "exchangeInitiate",
    });
  }

  get currentView() {
    const { currentView } = this.state;
    const { productData, consignmentId, orderId, sizeData } = this.props;
    switch (currentView) {
      case "exchangeComplete": {
        return <ExchangeComplete.component />;
      }
      case "exchangeInitiate":
      default: {
        return (
          <ExchangeInitiate.component
            productData={productData}
            consignmentId={consignmentId}
            orderId={orderId}
            exchangeStatus={this.handleCurrentView}
            sizeDetails={sizeData.sizeDetails}
            sizeChartId={sizeData.sizeChartId}
            tenantSizeLabel={sizeData.tenantSizeLabel}
            sizeMappingEnabled={sizeData.sizeMappingEnabled}
          />
        );
      }
    }
  }

  render() {
    const { data, className } = this.props;
    const { isModalOpen } = this.state;
    return (
      <Fragment>
        <Button
          className={`nw-consignment-cancel ${className}`}
          onClick={event => this.handleExchange(event)}
        >
          {" "}
          {data}{" "}
        </Button>
        <Modal
          className="nw-exchange-modal"
          isOpen={isModalOpen}
          onClose={this.closeModal}
        >
          {this.currentView}
        </Modal>
      </Fragment>
    );
  }
}

Exchange.defaultProps = {
  className: "",
};

Exchange.propTypes = {
  className: PropTypes.string,
  data: PropTypes.string.isRequired,
  productData: PropTypes.shape({}).isRequired,
  consignmentId: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  sizeData: PropTypes.shape({
    sizeDetails: PropTypes.arrayOf().isRequired,
  }).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: Exchange,
  component: Exchange,
};

export default ProjectComponent;
